import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {DenialLetterOdontoParams} from 'domain/usecases/private/authorizations-odonto/get-denial-letter-odonto';
import {getDenialLetterOdonto} from '../services/getDenialLetterOdonto';

export const useGetDenialLetterOdontoQuery = (params: DenialLetterOdontoParams) =>
	useQuery({
		queryKey: [QUERY_KEYS.AUTOSOL_DENIAL_LETTER_ODONTO, params],
		queryFn: async ({signal}) => getDenialLetterOdonto({...params, signal}),
		enabled: false,
	});
